/* Native upload compatibility for older theme surfaces; no provider SDK. */
(function () {
  const photoHost = document.currentScript.dataset.photoHost;
  const message = () => window.CustomerMedia?.copy?.().saveError || 'Your photo could not be saved. Please retry.';
  async function requireNative() {
    if (!window.CustomerMedia || !await window.CustomerMedia.enabled()) throw new Error(message());
    return window.CustomerMedia;
  }
  function metadata(choice) {
    return { url: choice.asset.url, handle: choice.asset.asset_id, asset_id: choice.asset.asset_id,
      filename: choice.file.name, mimetype: 'image/jpeg', size: choice.asset.bytes || choice.file.size,
      source: 'local_file_system', uploadId: choice.asset.asset_id };
  }
  function legacyUrl(value, variant = 'thumbnail') {
    try {
      const url = new URL(value);
      if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password || url.port
        || !['cdn.filestackcontent.com', 'cdn.filepicker.io', 'www.filestackapi.com', 'www.filestack.com', 'www.filepicker.io'].includes(url.hostname)) return '';
      if (url.hostname.startsWith('www.') && !/^\/api\/file\/[A-Za-z0-9]{20,64}\/?$/.test(url.pathname)) return '';
      const handle = url.pathname.split('/').filter(Boolean).pop();
      if (!/^[A-Za-z0-9]{20,64}$/.test(handle)) return '';
      return `https://${photoHost}/legacy/discountcrystals/${handle}/${variant === 'production' ? 'production' : 'thumbnail'}.jpg`;
    } catch (_) { return ''; }
  }
  function ownedUrl(value) {
    try { const url=new URL(value);return url.protocol==='https:' && url.hostname===photoHost
      && !url.port && !url.username && !url.password && !url.search && !url.hash
      && /^\/f\/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}\/[a-f0-9]{64}\/production\.jpg$/.test(url.pathname); }
    catch (_) {return false;}
  }
  async function adopt(source, signal) {
    const media = await requireNative();
    const asset = await media.adopt(source, signal);
    if (asset.status !== 'ready' || !asset.asset_id || !asset.url) throw new Error(message());
    return asset;
  }
  window.NativePhotoCompat = { legacyUrl, ownedUrl, adopt,
    requireNative,
    choose: async () => (await requireNative()).choose(),
    upload: async (file, options) => (await requireNative()).upload(file, options),
    metadata,
  };
  function nativePhoto(form) {
    try {
      const field = form.querySelector('[name="properties[Photo]"]') || form.querySelector('[name="properties[_Photo]"]');
      const url = new URL(field?.value || '');
      const match = /^\/f\/([a-f0-9-]{36})\/[a-f0-9]{64}\/production\.jpg$/.exec(url.pathname);
      return url.protocol === 'https:' && url.hostname === photoHost && match ? {asset_id:match[1], url:url.href} : null;
    } catch (_) { return null; }
  }
  const bound = new WeakSet(), submitting = new WeakSet();
  function property(form, name, value) {
    let field = form.querySelector(`[name="properties[${name}]"]`);
    if (!field) { field=document.createElement('input');field.type='hidden';field.name=`properties[${name}]`;form.append(field); }
    field.value=value;
  }
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (bound.has(form)) { bound.delete(form); return; }
    let asset = nativePhoto(form);
    const photoField = form.querySelector('[name="properties[Photo]"]') || form.querySelector('[name="properties[_Photo]"]');
    const legacySource = !asset && legacyUrl(photoField?.value) ? photoField.value : '';
    if (!asset && !legacySource) return;
    const scope = form.closest('product-info') || document;
    const formId = form.getAttribute('id');
    const coordinator = [...scope.querySelectorAll('ccm-live-preview-v3[data-surface="pdp"]')].find(item=>item.productForm===form || item.dataset.productFormId===formId);
    // These surfaces have their own guarded receipt integration.
    if ((coordinator?.isActive && coordinator.file)
      || [...scope.querySelectorAll('[data-default-photo-picker][data-media-mounted="true"]')].some(item=>item.dataset.productFormId===formId)
      || [...scope.querySelectorAll('.product-upload-photo[data-native-accessory-mounted="true"]')].some(item=>item.dataset.productFormId===formId)
      || form.closest('b2b-order-desk')) return;
    event.preventDefault();event.stopImmediatePropagation();
    if (submitting.has(form)) return;
    submitting.add(form);
    const submitter=event.submitter, host=form.closest('product-form');
    let error=form.querySelector('[data-native-compat-error]');
    if (!error) {error=document.createElement('p');error.dataset.nativeCompatError='true';error.setAttribute('role','alert');form.append(error);}
    error.textContent='';
    try {
      const media=await requireNative();
      if (legacySource) {
        asset = await adopt(legacySource);
        if (photoField.value !== legacySource) return;
        photoField.value = asset.url;
        property(form, '_media_legacy', 'true');
      }
      const cart=await window.StorefrontRequest.json(`${window.routes?.root || '/'}cart/update.js`, {method:'POST',body:'{}',credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json','Content-Type':'application/json'}},{timeoutMs:30000});
      let verified;
      try { verified=await media.associate(asset,cart.token); }
      catch (failure) {
        // A different browser may hold the public archived-photo capability.
        // The backend accepts this only for verified permanent historical assets.
        const restored=await adopt(asset.url);
        if (nativePhoto(form)?.asset_id !== asset.asset_id) return;
        property(form, '_media_legacy', 'true');
        verified=await media.associate(restored,cart.token);
      }
      const current=nativePhoto(form);
      if (!current || current.asset_id!==asset.asset_id) return;
      if (verified.asset_id!==asset.asset_id || !/^[a-f0-9]{64}$/.test(verified.order_receipt || '')) throw new Error(message());
      property(form,'_media_asset_id',verified.asset_id);property(form,'_media_order_receipt',verified.order_receipt);
      await new Promise(resolve=>setTimeout(resolve,0));
      if (nativePhoto(form)?.asset_id!==asset.asset_id) return;
      bound.add(form);
      try {form.requestSubmit(submitter || undefined);} finally {bound.delete(form);}
    } catch (failure) {error.textContent=failure.message || message();host?.setSubmissionLoading?.(false);}
    finally {submitting.delete(form);}
  },true);
  // Existing cart properties keep their provenance until checkout. Only exact
  // archived references are replaced, preserving quantity and every other option.
  let upgrading;
  async function upgradeCart() {
    if (upgrading) return upgrading;
    upgrading = (async () => {
      const request = window.StorefrontRequest;
      if (!request) throw new Error(message());
      let cart = await request.json(`${window.routes?.root || '/'}cart/update.js`, {
        method:'POST', body:'{}', credentials:'same-origin', cache:'no-store',
        headers:{Accept:'application/json','Content-Type':'application/json'},
      });
      for (const item of [...(cart.items || [])]) {
        const source = item.properties?.Photo || item.properties?._Photo;
        if (!legacyUrl(source) && item.properties?._media_legacy !== 'true') continue;
        const asset = await adopt(source);
        const verified = await (await requireNative()).associate(asset, cart.token);
        if (verified.asset_id !== asset.asset_id || !/^[a-f0-9]{64}$/.test(verified.order_receipt || '')) throw new Error(message());
        // A changed cart line gets a different Shopify key and cannot be overwritten.
        const fresh = await request.json(`${window.routes?.root || '/'}cart.js`, {credentials:'same-origin',cache:'no-store'});
        if (!fresh.items?.some(current => current.key === item.key && current.quantity === item.quantity)) throw new Error('Your cart changed. Please review it and try again.');
        const properties = {...item.properties, [item.properties.Photo ? 'Photo' : '_Photo']:asset.url,
          _media_asset_id:asset.asset_id, _media_order_receipt:verified.order_receipt, _media_legacy:'true'};
        cart = await request.json(`${window.routes?.root || '/'}cart/change.js`, {
          method:'POST', body:JSON.stringify({id:item.key,quantity:item.quantity,properties}),
          credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json','Content-Type':'application/json'},
        });
      }
      return cart;
    })().finally(() => {upgrading = null;});
    return upgrading;
  }
  window.NativePhotoCompat.upgradeCart = upgradeCart;
  const checkoutBypass = new WeakSet();
  async function checkout(event, target, resume) {
    if (checkoutBypass.has(target)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (target.dataset.mediaChecking === 'true') return;
    target.dataset.mediaChecking = 'true';
    try {
      await upgradeCart(); checkoutBypass.add(target);
      try { resume(); } finally { checkoutBypass.delete(target); }
    } catch (error) {
      let notice=document.querySelector('[data-media-cart-error]');
      if (!notice) {notice=document.createElement('p');notice.dataset.mediaCartError='true';notice.setAttribute('role','alert');target.after(notice);}
      notice.textContent=error.message || message();
    } finally {delete target.dataset.mediaChecking;}
  }
  document.addEventListener('click', event => {
    const link=event.target.closest?.('a[href]');
    if (link && /^\/checkout(?:[/?#]|$)/.test(new URL(link.href).pathname)) {
      checkout(event,link,() => window.location.assign(link.href));
    }
  },true);
  document.addEventListener('submit', event => {
    const form=event.target;
    if (form instanceof HTMLFormElement && event.submitter?.name === 'checkout') {
      checkout(event,form,() => form.requestSubmit(event.submitter));
    }
  },true);
  function rewriteVisiblePhotos(root = document) {
    root.querySelectorAll('a[href],img[src]').forEach(node => {
      const attr=node.tagName === 'A' ? 'href' : 'src';
      const owned=legacyUrl(node.getAttribute(attr),attr === 'href' ? 'production' : 'thumbnail');
      if (owned) node.setAttribute(attr,owned);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => rewriteVisiblePhotos(),{once:true});
  else rewriteVisiblePhotos();
  let rewritePending=false;
  new MutationObserver(() => {
    if (rewritePending) return;
    rewritePending=true; queueMicrotask(() => {rewritePending=false;rewriteVisiblePhotos();});
  }).observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['src','href']});
})();
